export const sectionNavigationPath = 'evaluations';
